export const CHART_CONTAINER_HEIGHT = 300;

export const INNER_CHART_HEIGHT = 200;

export const X_AXIS_LABEL_ROTATION = 45;

export const X_AXIS_TITLE_OFFSET = 60;

export const ONE_WEEK_AGO_DAYS = 7;

export const ONE_MONTH_AGO_DAYS = 31;

export const CHART_DATE_FORMAT = 'dd mmm';
